import React, { useState, useEffect } from "react";
import Navbar from "./navbar";
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';
import { useGetOrderByIdQuery } from "./store/api/orderApi";
import Spinner from 'react-bootstrap/Spinner';


const OrderDetails = ({ order }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1250);
    useEffect(() => {
        window.addEventListener("resize", () => {
            const ismobile = window.innerWidth < 1250;
            if (ismobile !== isMobile) setIsMobile(ismobile);
        }, false);
    }, [isMobile]);

    const { data: orderDetails, isLoading, refetch } = useGetOrderByIdQuery(order?.foodOrderid, { skip: !order?.foodOrderid });

    useEffect(() => {
      refetch();
    }, [])
    

    const getDate = (date) => {

        const d = new Date(date);
        let month = months[d.getMonth()];

        let dateString = `${d.getDate()}${month}${d.getFullYear()}`;
        return dateString;
    }

    return (
        order && !isLoading ?

            <>

                <section className=" shopping-cart-page">
                    {/* <div className="col-12 order-header">
                    <Navbar />
                </div> */}
                    {/* <div className="col-12 "> */}
                    {/******* order-details-section **********/}
                    <div className="shopping-cart-body card card-no-bg-border">
                        <div className="card-body">
                            <h1 className="main-body-title">
                                <span>
                                    <i className="fa fa-list-alt title-icon" aria-hidden="true"></i>
                                    Order Details
                                </span>
                            </h1>
                            <div className="thanks-text-section">
                                <h2 className="thanks-text">Thank you for the order!</h2>
                                <h2 className="sub-thanks-text">This is your receipt for the order placed.</h2>
                                <h2 className="sub-thanks-text"> Show this QR code at the check-in.</h2>
                            </div>

                            {
                                isMobile &&
                                <div>
                                    <div className="row">
                                        <div className="qr-code-wrapper" style={{ display: "flex", justifyContent: "center" }}>
                                            <img src={`https://api.qrserver.com/v1/create-qr-code/?size=227x100&data=${getDate(orderDetails?.orderDeliveryDate)}-${orderDetails?.orderNumber}`} className="img-thumbnail qr-img border-0" alt="QR-Code"></img>

                                        </div>
                                    </div>
                                </div>
                            }

                            <div className="row" style={{ marginTop: "2rem" }}>
                                {
                                    !isMobile &&
                                    <div style={{ marginBottom: "1rem" }}>
                                        <div className="qr-code-wrapper">
                                            <img src={`https://api.qrserver.com/v1/create-qr-code/?size=227x100&data=${getDate(orderDetails?.orderDeliveryDate)}-${orderDetails?.orderNumber}`} className="img-thumbnail qr-img border-0" alt="QR-Code"></img>

                                        </div>
                                    </div>
                                }
                                <div className="col-9 col-sm-10 col-lg-11 col-xl-11 col-xxl-11">
                                    <p className="Order-details-wrapper">
                                        <span className="order-details-1" title="Order number">Order number: </span>
                                        <span className="order-details-2" >{`${getDate(orderDetails?.orderDeliveryDate)}-${orderDetails?.orderNumber}`}</span>
                                    </p>
                                    <p className="Order-details-wrapper">
                                        <span className="order-details-1" title="Order Date">Order Date: </span>
                                        <span className="order-details-2" title="11/15/2021">{moment(orderDetails?.orderSubmittedDate).format("MM/DD/YYYY")}</span>
                                    </p>
                                    <p className="Order-details-wrapper">
                                        <span className="order-details-1" title="Delivery Date">Distribution Date: </span>
                                        <span className="order-details-2" title="11/15/2021">{moment(orderDetails?.orderDeliveryDate).format("MM/DD/YYYY")}</span>
                                    </p>
                                    <p className="Order-details-wrapper">
                                        <span className="order-details-1" title="Status">Status: </span>
                                        <span className="order-details-2" title="Submitted">{orderDetails?.orderStage}</span>
                                    </p>
                                </div>
                            </div>
                            <div className="grid-container" style={{ marginTop: "2rem" }}>
                                <div>
                                    <h3 className="item-title">Item</h3>
                                </div>
                                <div>
                                    <h3 className="item-title">Quantity</h3>
                                </div>
                                <div>
                                    <h3 className="item-title" style={{ textAlign: "right", marginRight: "1rem" }}>Points</h3>
                                </div>
                                {
                                    orderDetails?.listFoodOrder.map(item =>
                                        <>
                                            <div>
                                                {item.productName}
                                            </div>
                                            <div>
                                                {parseInt(item.orderQuantity)}
                                            </div>
                                            <div style={{ textAlign: "right", marginRight: "1rem" }}>
                                                {parseFloat(parseFloat(item.rateInPoints).toFixed(0) * parseFloat(item.orderQuantity)).toFixed(0)}
                                            </div>
                                        </>

                                    )
                                }
                            </div>

                            <div className="total-amount text-end" style={{ marginTop: "5rem" }}>
                                <h6>
                                    <strong><span className="total-heading">Total Points: </span>
                                        <span className="total-number">
                                            {/* <span className="text-muted">$</span> */}
                                            {parseFloat(orderDetails?.orderPoints).toFixed(0)}
                                        </span>
                                    </strong>
                                </h6>
                            </div>
                        </div>
                    </div>
                    {/******** order-details-section *********/}
                    {/* </div> */}
                </section>
            </>
            :
            <div className="spinner">
                <Spinner animation="border" />
            </div>
    )


}

export const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

export default OrderDetails;